import { render, staticRenderFns } from "./custInfo.vue?vue&type=template&id=2e4cd11c&scoped=true"
import script from "./custInfo.vue?vue&type=script&lang=js"
export * from "./custInfo.vue?vue&type=script&lang=js"
import style0 from "./custInfo.vue?vue&type=style&index=0&id=2e4cd11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cd11c",
  null
  
)

export default component.exports